'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Well = function Well(_ref) {
    var className = _ref.className,
        children = _ref.children,
        label = _ref.label,
        labelClassName = _ref.labelClassName,
        theme = _ref.theme;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('clearfix', className, theme && theme.well) },
        label && _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(labelClassName, theme && theme.label) },
            label
        ),
        children
    );
};

exports.default = Well;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/lib/Well/index.js
// module id = 861
// module chunks = 4 5 8 9 14